import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'modal-terminos-condiciones',
  templateUrl: './modal-terminos-condiciones.component.html',
  styleUrls: ['./modal-terminos-condiciones.component.scss']
})

export class ModalTerminosCondicionesComponent implements OnInit {

  terminosData: any = {
    titulo: 'Términos y Condiciones',
    texto: 'Cargando...'
  };

  constructor(
    private modal: ModalService, 
    private genServ : EcommerceGenericoService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    // Esperamos a que el servicio termine de cargar su configuración (initmaster)
    this.genServ.initmaster.subscribe({
      next: () => {
        this.cargarTerminos();
      },
      error: (err) => {
        this.terminosData.texto = "Error: No se pudo inicializar el servicio de configuración.";
      }
    });
  }

  async cargarTerminos() {
    let path = this.genServ.getTerminosCondiciones();
    
    if (path && path.endsWith('.json')) {
      if (!path.startsWith('/') && !path.startsWith('http')) {
        path = '/' + path;
      }

      try {
        const response = await fetch(path);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        this.terminosData = data;
      } catch (err) {
        console.error('Error cargando terminos', err);
        this.terminosData.texto = "No se pudieron cargar los términos y condiciones. Por favor, intente más tarde.";
      }
    } else if (path) {
      this.terminosData.texto = path;
    }
  }

  aceptar() {
    this.modal.close('modal-terminos-condiciones');
  }

  get TerminosCondiciones(){
    return this.terminosData.texto;
  }

  get Titulo() {
    return this.terminosData.titulo;
  }

}
